import { DetalleTabla } from "@/pages/data-center/components/DetalleTabla";
import { CFDetailTable } from "@/pages/data-center/functional-core/CFDetailTable";
import RoleGuard from "@/pages/role-guard";
import { createTableDetailsBreadcrumb } from "@/queries/data-center/data-center.api";
import { Permissions } from "@/utils/permissions";
import type { QueryClient } from "@tanstack/react-query";
import { lazy } from "react";
import {
  makeHandle,
  makeOptionalNameHandle,
  withNotFoundRedirect,
  type LoaderParams,
} from "./router.helpers";

const CentroDeDatos = lazy(() => import("@/pages/data-center"));

const REGISTRY_PERMISSIONS = [
  Permissions["data-center"]["read-registry"],
  Permissions["data-center"].read,
];

export const createCentroDeDatosRoutes = (queryClient: QueryClient) => ({
  path: "centro-de-datos",
  children: [
    {
      index: true,
      element: (
        <RoleGuard permissions={[Permissions["data-center"].read]}>
          <CentroDeDatos />
        </RoleGuard>
      ),
      handle: makeHandle({ label: "Centro de datos" }),
    },
    {
      path: ":id",
      element: (
        <RoleGuard permissions={REGISTRY_PERMISSIONS}>
          <DetalleTabla />
        </RoleGuard>
      ),
      loader: ({ params }: LoaderParams) =>
        withNotFoundRedirect(
          () => createTableDetailsBreadcrumb(queryClient, params.id || "")(),
          "/centro-de-datos",
        ),
      handle: makeOptionalNameHandle({
        label: "Centro de datos",
        path: "/centro-de-datos",
      }),
    },
    {
      path: "core-funcional/:id",
      element: (
        <RoleGuard permissions={REGISTRY_PERMISSIONS}>
          <CFDetailTable />
        </RoleGuard>
      ),
      handle: {
        breadcrumb: (match: { params?: { id?: string } }) => {
          const crumbs: { label: string; path?: string }[] = [
            {
              label: "Centro de datos",
              path: "/centro-de-datos?core=true",
            },
          ];
          if (match?.params?.id) {
            crumbs.push({ label: match.params.id });
          }
          return crumbs;
        },
      },
    },
  ],
});
